import React, { useMemo } from 'react';

import { useChildComponent } from '@gogame/hooks-ts';

import AdBlockDialog from './AdBlockDialog';

const checkAdBlock = () => {
  return new Promise((resolve, reject) => {
    let div = document.createElement('div');
    div.className = 'adsbox ad spam banner adv advertising promo';
    div.innerHTML = '&nbsp;';

    let body = document.querySelector('body');
    body.appendChild(div);
    //parallel processing. Check available ad div
    setTimeout(() => {
      if (div.offsetHeight === 0) {
        div.parentNode.removeChild(div);
        reject(false);
      } else {
        div.parentNode.removeChild(div);
        resolve(true);
      }
    });
  });
};

const AdBlockChecker = ({ children }) => {
  const [childComponent, showChildComponent] = useChildComponent();
  useMemo(() => {
    checkAdBlock().catch(() => {
      showChildComponent(AdBlockDialog);
    });
  }, []);

  return (
    <React.Fragment>
      {childComponent}
      {children}
    </React.Fragment>
  );
};

export default AdBlockChecker;
